import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IllustrationSuccessSvg } from "./IllustrationSuccessSvg.mjs";
const IllustrationSuccess = () => /* @__PURE__ */ jsx(Box, { component: IllustrationSuccessSvg });
export {
  IllustrationSuccess
};
